export const videos = [
  {
    id: "v1",
    title: "清晨六点的城市，藏着最治愈的一小时",
    categorySlug: "life",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20city%20street%20at%20sunrise%20with%20soft%20golden%20light%20and%20long%20shadows%2C%20empty%20road%2C%20warm%20neutral%20tones%2C%20clean%20cinematic%20editorial%20photography%2C%20peaceful%20atmosphere&width=800&height=450&seq=vid-01&orientation=landscape",
    duration: 168,
    publishDate: "2026-10-12",
    views: 184300,
    likes: 9231,
    author: "早起星球",
    description:
      "很多人没见过清晨六点的城市。街道还没醒，光很轻，风也慢。这一期我们带上相机，在天亮之前走上街头，记录下最安静也最治愈的一个小时。",
  },
  {
    id: "v2",
    title: "10 分钟收纳好一个乱到崩溃的衣柜",
    categorySlug: "life",
    cover:
      "https://readdy.ai/api/search-image?query=neatly%20organized%20wardrobe%20with%20folded%20clothes%20and%20wooden%20hangers%2C%20bright%20airy%20room%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20home%20editorial%20photography%2C%20calm%20order&width=800&height=450&seq=vid-02&orientation=landscape",
    duration: 452,
    publishDate: "2026-10-11",
    views: 132900,
    likes: 7014,
    author: "整理成瘾",
    description:
      "换季衣柜又爆炸了？这期我用了三个小方法，把堆成山的衣服塞回衣柜还留出空隙。全程无剪辑加速，跟着一起动手就可以了。",
  },
  {
    id: "v3",
    title: "一个人去海边住了三天，什么都没做",
    categorySlug: "life",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20seaside%20view%20from%20a%20small%20window%20with%20soft%20pastel%20sky%20and%20gentle%20waves%2C%20airy%20minimal%20scene%2C%20warm%20tones%2C%20cinematic%20editorial%20photography%2C%20serene%20mood&width=800&height=450&seq=vid-03&orientation=landscape",
    duration: 611,
    publishDate: "2026-10-09",
    views: 98200,
    likes: 5820,
    author: "慢慢生活",
    description:
      "请了三天假，订了一间离海最近的房子，没有攻略没有打卡，只是每天看海、发呆、煮一碗面。这期视频有点慢，希望你也能慢下来。",
  },
  {
    id: "v4",
    title: "把阳台改造成小书房，只花了两百块",
    categorySlug: "life",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20small%20balcony%20turned%20into%20reading%20corner%20with%20plants%20and%20wooden%20shelf%2C%20soft%20natural%20light%2C%20warm%20neutral%20tones%2C%20clean%20home%20editorial%20photography&width=800&height=450&seq=vid-04&orientation=landscape",
    duration: 327,
    publishDate: "2026-10-07",
    views: 76500,
    likes: 4310,
    author: "小空间实验室",
    description:
      "只有两平米的阳台，也能拥有一个安静的角落。这次用最少的预算做了软装改造，植物、书桌和一盏灯，看书的时候连时间都变慢了。",
  },
  {
    id: "v5",
    title: "周末露营第一次就成功是什么体验",
    categorySlug: "life",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20weekend%20camping%20tent%20in%20a%20green%20meadow%20at%20dusk%20with%20warm%20fairy%20lights%2C%20soft%20light%2C%20warm%20tones%2C%20clean%20outdoor%20editorial%20photography%2C%20peaceful%20evening&width=800&height=450&seq=vid-05&orientation=landscape",
    duration: 538,
    publishDate: "2026-10-05",
    views: 88900,
    likes: 5102,
    author: "周末去哪儿",
    description:
      "人生第一次露营，手忙脚乱搭帐篷、生火、煮咖啡，好在最后都成功了。分享一份新手友好的露营清单，看完你也能说走就走。",
  },
  {
    id: "v6",
    title: "街边小馆的招牌牛肉面，配方被我复刻了",
    categorySlug: "food",
    cover:
      "https://readdy.ai/api/search-image?query=steaming%20bowl%20of%20beef%20noodles%20on%20a%20clean%20light%20table%20with%20fresh%20herbs%2C%20soft%20daylight%2C%20warm%20appetizing%20tones%2C%20high%20detail%20culinary%20editorial%20photography&width=800&height=450&seq=vid-06&orientation=landscape",
    duration: 421,
    publishDate: "2026-10-12",
    views: 219800,
    likes: 12840,
    author: "厨房日记",
    description:
      "这家开了二十年的小馆，牛肉面每天限量。蹲点很久终于要到关键步骤，今天完整复刻一遍，汤头、牛肉、面条一个都不少。",
  },
  {
    id: "v7",
    title: "深夜饿了，教你五分钟搞定一碗拌饭",
    categorySlug: "food",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20rice%20bowl%20with%20egg%20and%20vegetables%20on%20a%20simple%20plate%2C%20soft%20warm%20light%2C%20clean%20minimal%20background%2C%20appetizing%20editorial%20food%20photography&width=800&height=450&seq=vid-07&orientation=landscape",
    duration: 96,
    publishDate: "2026-10-11",
    views: 156700,
    likes: 8901,
    author: "夜宵研究所",
    description:
      "半夜饿了外卖太慢，冰箱里有什么就做什么。这碗拌饭五分钟出锅，成本不到十块，味道却一点不将就。",
  },
  {
    id: "v8",
    title: "在家复刻网红舒芙蕾，翻车三次后终于成功",
    categorySlug: "food",
    cover:
      "https://readdy.ai/api/search-image?query=fluffy%20souffle%20pancake%20stack%20with%20cream%20and%20berries%20on%20a%20clean%20plate%2C%20soft%20warm%20light%2C%20minimal%20bright%20background%2C%20appetizing%20dessert%20editorial%20photography&width=800&height=450&seq=vid-08&orientation=landscape",
    duration: 349,
    publishDate: "2026-10-09",
    views: 178300,
    likes: 10230,
    author: "甜点计划",
    description:
      "为了做好这份舒芙蕾，我翻车了三次。总结出最容易失败的两个点，新手照着做也能做出会摇晃的松软口感，一起来试试。",
  },
  {
    id: "v9",
    title: "逛了一整天菜市场，买回一堆没见过的食材",
    categorySlug: "food",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20fresh%20market%20stall%20with%20colorful%20vegetables%20and%20fruits%2C%20warm%20daylight%2C%20clean%20lively%20scene%2C%20appetizing%20editorial%20food%20photography&width=800&height=450&seq=vid-09&orientation=landscape",
    duration: 587,
    publishDate: "2026-10-06",
    views: 94300,
    likes: 5230,
    author: "吃货地图",
    description:
      "菜市场才是城市的心脏。这次带着好奇逛了一整天，把没见过的食材一样样买回来，顺便教你怎么挑最新鲜的那一筐。",
  },
  {
    id: "v10",
    title: "一个人的火锅，也可以很有仪式感",
    categorySlug: "food",
    cover:
      "https://readdy.ai/api/search-image?query=individual%20hot%20pot%20set%20with%20fresh%20ingredients%20on%20a%20clean%20table%2C%20steam%20rising%2C%20warm%20cozy%20light%2C%20minimal%20background%2C%20appetizing%20editorial%20photography&width=800&height=450&seq=vid-10&orientation=landscape",
    duration: 264,
    publishDate: "2026-10-04",
    views: 112500,
    likes: 6780,
    author: "一人食光",
    description:
      "一个人吃饭不是将就。这份一人食火锅清单，锅底、蘸料、配菜全都安排明白，独处的时候也要好好吃饭。",
  },
  {
    id: "v11",
    title: "只用一把吉他弹哭了整个直播间",
    categorySlug: "music",
    cover:
      "https://readdy.ai/api/search-image?query=acoustic%20guitar%20close%20up%20in%20warm%20moody%20light%20with%20soft%20bokeh%20background%2C%20rich%20amber%20tones%2C%20clean%20cinematic%20editorial%20photography%2C%20emotional%20mood&width=800&height=450&seq=vid-11&orientation=landscape",
    duration: 242,
    publishDate: "2026-10-12",
    views: 302400,
    likes: 21030,
    author: "阿哲弹唱",
    description:
      "没有伴奏，没有修音，就是一把吉他和一个安静的夜晚。这首歌送给我很重要的一个人，也送给正在听的你。",
  },
  {
    id: "v12",
    title: "翻唱经典老歌，前奏一起就破防了",
    categorySlug: "music",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20microphone%20and%20piano%20in%20a%20warm%20studio%20with%20soft%20spotlight%2C%20rich%20amber%20tones%2C%20clean%20minimal%20background%2C%20cinematic%20editorial%20photography&width=800&height=450&seq=vid-12&orientation=landscape",
    duration: 318,
    publishDate: "2026-10-10",
    views: 198600,
    likes: 13920,
    author: "晚风翻唱",
    description:
      "有些歌听过很多遍，可前奏一响还是会起鸡皮疙瘩。这一次用最朴素的方式重新唱一遍，愿它还能打动你。",
  },
  {
    id: "v13",
    title: "用八个杯子敲出整首歌，你听过吗",
    categorySlug: "music",
    cover:
      "https://readdy.ai/api/search-image?query=eight%20glass%20cups%20filled%20with%20water%20on%20a%20clean%20table%20with%20small%20mallet%2C%20soft%20warm%20light%2C%20minimal%20bright%20background%2C%20creative%20editorial%20photography&width=800&height=450&seq=vid-13&orientation=landscape",
    duration: 187,
    publishDate: "2026-10-08",
    views: 143200,
    likes: 9210,
    author: "奇怪乐器社",
    description:
      "你以为只能用来喝水的杯子，其实是一件乐器。调好水量之后，八个杯子就能敲出一整段旋律，来听听看。",
  },
  {
    id: "v14",
    title: "深夜练琴的第 100 天，进步肉眼可见",
    categorySlug: "music",
    cover:
      "https://readdy.ai/api/search-image?query=hands%20playing%20piano%20keys%20in%20a%20dim%20room%20with%20a%20warm%20lamp%2C%20soft%20bokeh%2C%20rich%20tones%2C%20clean%20cinematic%20editorial%20photography%2C%20focused%20mood&width=800&height=450&seq=vid-14&orientation=landscape",
    duration: 356,
    publishDate: "2026-10-06",
    views: 87300,
    likes: 5640,
    author: "练琴打卡",
    description:
      "从第一天磕磕绊绊到今天，整整一百天。剪了一段前后对比，想告诉每一个正在坚持的人：慢慢来，真的会变好。",
  },
  {
    id: "v15",
    title: "在街头即兴合唱，路人全停下来听",
    categorySlug: "music",
    cover:
      "https://readdy.ai/api/search-image?query=street%20musician%20performing%20at%20dusk%20with%20warm%20string%20lights%20and%20small%20crowd%2C%20soft%20glow%2C%20cinematic%20editorial%20photography%2C%20warm%20cozy%20atmosphere&width=800&height=450&seq=vid-15&orientation=landscape",
    duration: 289,
    publishDate: "2026-10-03",
    views: 245100,
    likes: 17230,
    author: "街头的声音",
    description:
      "傍晚的广场，一把琴，一个音箱，就这么唱了起来。后来越来越多的人加入，陌生的声音混在一起，意外地好听。",
  },
  {
    id: "v16",
    title: "残血一打三极限翻盘，手都在抖",
    categorySlug: "game",
    cover:
      "https://readdy.ai/api/search-image?query=gaming%20keyboard%20and%20mouse%20with%20neon%20accent%20glow%20in%20a%20dark%20room%2C%20vivid%20lights%2C%20clean%20modern%20background%2C%20cinematic%20editorial%20photography%2C%20intense%20mood&width=800&height=450&seq=vid-16&orientation=landscape",
    duration: 96,
    publishDate: "2026-10-12",
    views: 412300,
    likes: 28840,
    author: "翻盘王",
    description:
      "队友全倒了，血条只剩一丝，对面三个人压上来。这一波我赌了一把，结果成了本局最爽的高光，回放看了十遍。",
  },
  {
    id: "v17",
    title: "这款独立游戏，画面美到我想截图当壁纸",
    categorySlug: "game",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20stylized%20game%20scene%20with%20soft%20painterly%20landscape%20and%20warm%20light%2C%20vivid%20dreamy%20tones%2C%20clean%20minimal%20background%2C%20cinematic%20editorial%20photography&width=800&height=450&seq=vid-17&orientation=landscape",
    duration: 508,
    publishDate: "2026-10-10",
    views: 167800,
    likes: 11230,
    author: "试玩日记",
    description:
      "最近挖到一款小众独立游戏，玩法简单但美术太惊艳了。这一期带大家从头玩一遍，随手暂停都是一张壁纸。",
  },
  {
    id: "v18",
    title: "新手第一次玩恐怖游戏，全程捂眼睛",
    categorySlug: "game",
    cover:
      "https://readdy.ai/api/search-image?query=creepy%20dim%20hallway%20in%20a%20video%20game%20with%20flickering%20warm%20light%2C%20moody%20dark%20tones%2C%20clean%20cinematic%20editorial%20photography%2C%20suspenseful%20atmosphere&width=800&height=450&seq=vid-18&orientation=landscape",
    duration: 623,
    publishDate: "2026-10-07",
    views: 203900,
    likes: 14620,
    author: "胆子很小",
    description:
      "朋友非要我玩这款恐怖游戏，说很简单。结果开场十分钟我就开始后悔了。全程高能，胆子小的建议白天观看。",
  },
  {
    id: "v19",
    title: "用最笨的方法通关，结果还破了个纪录",
    categorySlug: "game",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20arcade%20controller%20on%20a%20clean%20desk%20with%20warm%20accent%20light%2C%20vivid%20cozy%20tones%2C%20minimal%20background%2C%20editorial%20photography%2C%20playful%20mood&width=800&height=450&seq=vid-19&orientation=landscape",
    duration: 745,
    publishDate: "2026-10-05",
    views: 121400,
    likes: 7890,
    author: "佛系玩家",
    description:
      "别人研究速通，我偏偏想用最笨的走法通关。没想到这一路阴差阳错，居然刷新了自己的最好成绩，分享一下思路。",
  },
  {
    id: "v20",
    title: "和朋友开黑翻车实录，笑到停不下来",
    categorySlug: "game",
    cover:
      "https://readdy.ai/api/search-image?query=two%20controllers%20side%20by%20side%20on%20a%20sofa%20scene%20with%20warm%20cozy%20light%2C%20vivid%20tones%2C%20clean%20minimal%20background%2C%20editorial%20photography%2C%20playful%20fun%20mood&width=800&height=450&seq=vid-20&orientation=landscape",
    duration: 434,
    publishDate: "2026-10-02",
    views: 158200,
    likes: 10450,
    author: "开黑兄弟",
    description:
      "说好了一起上分，结果三局全崩。这期剪辑了各种离谱操作和爆笑对话，友情提示：不要在喝水的看这个视频。",
  },
  {
    id: "v21",
    title: "室友半夜说梦话，被我全程录了下来",
    categorySlug: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20bedroom%20scene%20with%20cozy%20blanket%20and%20warm%20lamp%20light%2C%20fun%20colorful%20props%2C%20clean%20minimal%20background%2C%20bright%20editorial%20photography%2C%20cheerful%20mood&width=800&height=450&seq=vid-21&orientation=landscape",
    duration: 187,
    publishDate: "2026-10-11",
    views: 356700,
    likes: 26430,
    author: "宿舍日常",
    description:
      "室友最近总说梦话，内容一天比一天离谱。这期整理了一整周的录音合集，字幕都是他来第二天自己配的，别问他现在心情如何。",
  },
  {
    id: "v22",
    title: "挑战全网最社死的点单方式，店员表情绝了",
    categorySlug: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20playful%20cafe%20counter%20scene%20with%20colorful%20signage%20and%20warm%20light%2C%20fun%20vivid%20tones%2C%20clean%20minimal%20background%2C%20editorial%20photography%2C%20cheerful%20mood&width=800&height=450&seq=vid-22&orientation=landscape",
    duration: 264,
    publishDate: "2026-10-09",
    views: 289100,
    likes: 19870,
    author: "整活小分队",
    description:
      "朋友出了一堆奇怪的点单要求，让我照着念。本来以为会被赶出去，没想到店员全程配合，最后那段真的笑出声。",
  },
  {
    id: "v23",
    title: "把家里的猫当成外卖员训练了一天",
    categorySlug: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=adorable%20cat%20with%20a%20tiny%20bright%20bandana%20in%20a%20sunny%20room%2C%20warm%20soft%20light%2C%20clean%20minimal%20background%2C%20bright%20playful%20editorial%20photography&width=800&height=450&seq=vid-23&orientation=landscape",
    duration: 302,
    publishDate: "2026-10-06",
    views: 421900,
    likes: 31240,
    author: "猫主子频道",
    description:
      "我一直想训练猫帮我拿东西，于是一边投喂一边教了一整天。结果是它很满意，我很崩溃。全过程记录，笑点密集。",
  },
  {
    id: "v24",
    title: "模仿同事开会的十种表情，看谁先笑场",
    categorySlug: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20office%20desk%20scene%20with%20colorful%20sticky%20notes%20and%20warm%20light%2C%20fun%20vivid%20tones%2C%20clean%20minimal%20background%2C%20editorial%20photography%2C%20cheerful%20mood&width=800&height=450&seq=vid-24&orientation=landscape",
    duration: 158,
    publishDate: "2026-10-04",
    views: 176300,
    likes: 12480,
    author: "办公室监控",
    description:
      "每天开会都在观察大家的微表情，这次终于忍不住还原了一遍。从强装镇定到灵魂出窍，你身边的同事一定有同款。",
  },
];

export type Video = (typeof videos)[number];